import { ReactElement } from 'react';
import useStyles from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslate } from 'hooks/use-translate';
import { change, WrappedFieldInputProps } from 'redux-form';
import { SDSInfo } from 'interface';
import { AppDispatch } from 'const';
/* Components */
import {
  ClassNameMap,
  TextField as MUITextField,
  StandardTextFieldProps,
  Typography,
} from '@mui/material';

interface TextFieldProps extends StandardTextFieldProps {
  label?: string;
  input?: WrappedFieldInputProps;
  meta?: {
    touched: boolean;
    invalid: boolean;
    error: boolean;
  };
  type?: string;
  section?: string;
  translation?: boolean;
  componentId?: number | string | null;
  renderEndAdorment?: () => ReactElement;
}

const TextField = ({
  type,
  label,
  input,
  meta,
  section,
  translation,
  componentId,
  renderEndAdorment,
  ...custom
}: TextFieldProps) => {
  const customClasses: ClassNameMap = useStyles();
  const { classes } = custom;
  const { touched, invalid, error } = meta ?? {};
  const dispatch: AppDispatch = useDispatch();
  const sdsInfo: SDSInfo | null = useSelector(
    (state: any) => state.pageReducer.sdsInfo
  );
  const showOriginalText: boolean = useSelector(
    (state: any) => state.pageReducer.showOriginalText
  );
  const formFieldName = input?.name as keyof SDSInfo | undefined;

  const { renderAdormentIcon, loading, inputValue } = useTranslate(
    sdsInfo?.original_data?.language_code,
    sdsInfo?.language_code,
    null,
    componentId,
    formFieldName,
    null,
    translatedString => {
      if (!section || !formFieldName) return;
      dispatch(change(section, formFieldName, translatedString));
    }
  );

  return (
    <div className={customClasses.container}>
      <MUITextField
        label={label}
        error={touched && invalid}
        helperText={touched && error}
        classes={classes}
        variant="filled"
        type={type}
        disabled={loading}
        {...input}
        {...custom}
        InputProps={{
          ...custom?.InputProps,
          endAdornment: renderEndAdorment
            ? renderEndAdorment()
            : translation
            ? renderAdormentIcon()
            : undefined,
          style: {
            padding: label ? '25px 12px 8px 12px' : '18px 12px 16px 12px',
          },
        }}
      />
      {showOriginalText && !!inputValue && (
        <Typography
          variant="caption"
          fontWeight={500}
          whiteSpace={'pre-line'}
          fontStyle={'italic'}
        >
          {inputValue}
        </Typography>
      )}
    </div>
  );
};

export default TextField;
